// extracted by mini-css-extract-plugin
module.exports = {"top":"DiversityCenter-module--top--2sAc8","pageTitle":"DiversityCenter-module--pageTitle--1_zZW","socialLinks":"DiversityCenter-module--socialLinks--_SjZP"};